import { Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'pos-order-fullwidth',
  templateUrl: './pos-order-fullwidth.component.html',
  styleUrls: ['./pos-order-fullwidth.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PosOrderFullwidthComponent {
  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.updateMobileResolution();
  }

  public isMobileResolution: boolean;
  public isPosRoute: boolean;
  @Input() selectedMenu: string;
  @Output() selectedMenuChange = new EventEmitter<string>();
  isRestaurant: boolean;

  /**
   * Constructor
   */
  constructor(private router: Router) {
    this.isMobileResolution = window.innerWidth < 1179;
    this.isRestaurant = localStorage.getItem('isRestaurant') === 'true';
    this.isPosRoute = false;

    // Listen for route changes and check if it includes "pos"
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd)) // Only process NavigationEnd events
      .subscribe((event: NavigationEnd) => {
        this.checkIfPosRoute(event.url);
      });

    // Check the current route on initialization
    this.checkIfPosRoute(this.router.url);
  }

  private updateMobileResolution(): void {
    this.isMobileResolution = window.innerWidth < 1179;
  }

  goToPosMenu() {
    this.selectedMenu = 'posMenu';
    this.selectedMenuChange.emit(this.selectedMenu);
  }

  private checkIfPosRoute(url: string): void {
    this.isPosRoute = url.includes('pos'); // Set to true if "pos" is in the route
  }
}
